import React from 'react';
import './Footer.css';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import KesariRoundLogo from '../../assets/images/kesari-round-logo.webp';
import KesariTextLogo from '../../assets/images/kesari-text-logo.webp';
import LocationIcon from '../../assets/images/location-icon.png';
import PhoneIcon from '../../assets/images/phone-icon.png';
import EmailIcon from '../../assets/images/email-icon.png';
import TimeIcon from '../../assets/images/time-icon.png';
import PrivacyIcon from '../../assets/images/privacy.png';

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box component="footer" className="footer">
      <Box
        sx={{
          display: isMobile ? 'inline' : 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: isMobile ? 'column' : 'row',
          gap: '15px',
          marginTop: !isMobile ? '30px' : '60px',
          marginBottom: '30px',
          marginLeft: !isMobile ? '120px' : '60px',
          marginRight: !isMobile ? '120px' : '60px'
        }}>
        {isMobile ? (
          <Box textAlign="center">
            <Box
              component="img"
              src={KesariRoundLogo}
              alt="Kesari Logo"
              className="footer-logo"
              sx={{ width: '60px', height: '60px', mr: 2 }}
            />
            <Box
              component="img"
              src={KesariTextLogo}
              alt="Kesari Logo"
              sx={{ filter: 'brightness(0) invert(1)', width: '120px', height: '60px' }}
            />
          </Box>
        ) : (
          <Box
            component="img"
            src={KesariRoundLogo}
            alt="Kesari Logo"
            className="footer-logo"
            sx={{ width: 80, height: 80 }}
          />
        )}

        {!isMobile ? (
          <Box>
            <Box className="footer-contact" mb={1}>
              <Box className="footer-icon-text">
                <Box
                  component="img"
                  src={PhoneIcon}
                  alt="phone-logo"
                  sx={{
                    filter: 'brightness(0) invert(1)',
                    width: '18px',
                    height: '19px',
                    transition: 'filter 0.3s',
                    mr: 1
                  }}
                />
                <Typography
                  component="a"
                  href="tel:+91 9920305678"
                  className="contact-details-typo"
                  sx={{
                    textDecoration: 'none',
                    transition: 'color 0.3s',
                    mr: 2,
                    '&:hover': {
                      color: '#ffcc00'
                    },
                    '&:hover + img': {
                      filter: 'brightness(0) invert(0)'
                    }
                  }}>
                  +91 9920305678
                </Typography>
              </Box>
              <Box className="footer-icon-text">
                <Box
                  component="img"
                  src={EmailIcon}
                  alt="email-logo"
                  ml={4}
                  sx={{
                    filter: 'brightness(0) invert(1)',
                    width: '18px',
                    height: '15px',
                    transition: 'filter 0.3s',
                    mr: 1
                  }}
                />
                <Typography
                  component="a"
                  href="mailto:inbound@kesari.in"
                  className="contact-details-typo"
                  sx={{
                    textDecoration: 'none',
                    transition: 'color 0.3s',
                    '&:hover': {
                      color: '#ffcc00'
                    }
                  }}>
                  inbound@kesari.in
                </Typography>
              </Box>
              <Box className="footer-icon-text">
                <Box
                  component="img"
                  src={TimeIcon}
                  alt="time-logo"
                  ml={4}
                  sx={{
                    filter: 'brightness(0) invert(1)',
                    width: '16px',
                    height: '17px',
                    transition: 'filter 0.3s',
                    mr: 1
                  }}
                />
                <Typography
                  className="contact-details-typo"
                  sx={{
                    transition: 'color 0.3s',
                    '&:hover': {
                      color: '#ffcc00'
                    },
                    whiteSpace: 'nowrap'
                  }}>
                  10 am - 6 pm (IST) | Monday to Friday
                </Typography>
              </Box>
            </Box>
            <Box className="footer-info" sx={{ display: 'flex', alignItems: 'center' }}>
              <Box
                component="img"
                src={LocationIcon}
                alt="location-logo"
                sx={{
                  filter: 'brightness(0) invert(1)',
                  width: '15px',
                  height: '21px',
                  mr: 1,
                  mb: 0
                }}
              />
              <Typography className="contact-details-typo" sx={{ whiteSpace: 'nowrap' }}>
                3105, Kohinoor Square, 31st Floor, N.C.Kelkar Marg, Shivaji Park, Mumbai,
                Maharashtra - 400028.
              </Typography>
            </Box>
            <Typography
              className="contact-details-typo"
              sx={{
                mt: 1,
                transition: 'color 0.3s',
                '&:hover': {
                  color: '#ffcc00'
                }
              }}>
              Message us anytime — we reply within 24 hours.
            </Typography>
          </Box>
        ) : (
          <Box className="footer-section" sx={{ textAlign: isMobile ? 'center' : 'left' }}>
            <Box
              className="footer-contact"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
              <Box
                className="footer-icon-text"
                sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Box
                  component="img"
                  src={PhoneIcon}
                  alt="phone-logo"
                  sx={{
                    filter: 'brightness(0) invert(1)',
                    width: '18px',
                    height: '19px',
                    transition: 'filter 0.3s',
                    mr: 1
                  }}
                />
                <Typography
                  component="a"
                  href="tel:+91 9920305678"
                  className="contact-details-typo"
                  sx={{
                    textDecoration: 'none',
                    transition: 'color 0.3s',
                    '&:hover': {
                      color: '#ffcc00'
                    }
                  }}>
                  +91 9920305678
                </Typography>
              </Box>

              <Box
                className="footer-icon-text"
                sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Box
                  component="img"
                  src={EmailIcon}
                  alt="email-logo"
                  sx={{
                    filter: 'brightness(0) invert(1)',
                    width: '18px',
                    height: '15px',
                    transition: 'filter 0.3s',
                    mr: 1
                  }}
                />
                <Typography
                  component="a"
                  href="mailto:inbound@kesari.in"
                  className="contact-details-typo"
                  sx={{
                    textDecoration: 'none',
                    transition: 'color 0.3s',
                    '&:hover': {
                      color: '#ffcc00'
                    }
                  }}>
                  inbound@kesari.in
                </Typography>
              </Box>

              <Box
                className="footer-icon-text"
                sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Box
                  component="img"
                  src={TimeIcon}
                  alt="time-logo"
                  sx={{
                    filter: 'brightness(0) invert(1)',
                    width: '16px',
                    height: '17px',
                    transition: 'filter 0.3s',
                    mr: 1
                  }}
                />
                <Typography
                  className="contact-details-typo"
                  sx={{
                    transition: 'color 0.3s',
                    '&:hover': {
                      color: '#ffcc00'
                    }
                  }}>
                  10 am - 6 pm (IST)
                </Typography>
              </Box>
            </Box>
            <Box
              className="footer-info"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                mt: 1
              }}>
              <Box display="flex">
                <Box
                  component="img"
                  src={LocationIcon}
                  alt="location-logo"
                  sx={{
                    filter: 'brightness(0) invert(1)',
                    width: '15px',
                    height: '21px',
                    mr: 1,
                    mb: 1
                  }}
                />
                <Box>
                  <Typography className="contact-details-typo">
                    3105, Kohinoor Square, 31st Floor,
                  </Typography>
                  <Typography className="contact-details-typo">
                    N.C.Kelkar Marg, Shivaji Park,
                  </Typography>
                  <Typography className="contact-details-typo">
                    Mumbai, Maharashtra - 400028.
                  </Typography>
                </Box>
              </Box>
              <Typography
                className="contact-details-typo"
                sx={{
                  mt: 1.5,
                  transition: 'color 0.3s',
                  '&:hover': {
                    color: '#ffcc00'
                  }
                }}>
                Message us anytime — we reply within 24 hours.
              </Typography>
            </Box>
          </Box>
        )}
      </Box>

      {/* <Box
        sx={{
          width: '100%',
          textAlign: 'center',
          mt: 2,
          color: '#FFFFFF',
          fontSize: '12px',
          opacity: 0.8
        }}>
        <Typography>
          &copy; 1983-{new Date().getFullYear()} Kesari Tours Pvt Ltd. Rights reserved.
        </Typography>
      </Box> */}

      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: 'center',
          mt: 2,
          color: '#FFFFFF',
          fontSize: '12px',
          opacity: 0.8
        }}>
        {/* Left Side: Copyright */}
        <Typography
          sx={{
            fontSize: '17px',
            color: '#FFFFFF',
            opacity: 0.8,
            textAlign: { xs: 'center', sm: 'left' },
            ml: { xs: 2, sm: 4, md: 10, lg: 25 }
          }}>
          &copy; 1983–{new Date().getFullYear()} Kesari Tours Pvt Ltd. Rights reserved.
        </Typography>

        {/* Right Side: Privacy Policy */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: { xs: 'center', sm: 'flex-end' },
            mt: { xs: 1, sm: 0 },
            mr: { xs: 2, sm: 4, md: 10, lg: 25 }
          }}>
          <Box
            component="img"
            src={PrivacyIcon}
            alt="privacy-logo"
            sx={{
              filter: 'brightness(0) invert(1)',
              width: '16px',
              height: '17px',
              transition: 'filter 0.3s',
              mr: 1
            }}
          />
          <Typography
            component="a"
            href="/privacy-policy"
            sx={{
              textDecoration: 'none',
              fontSize: { xs: '14px', sm: '16px', md: '17px' },
              color: '#FFFFFF',
              transition: 'color 0.3s',
              '&:hover': {
                color: '#ffcc00'
              }
            }}>
            Privacy Policy
          </Typography>
        </Box>
      </Box>

      {/* <Box className="footer-pattern" /> */}
    </Box>
  );
};

export default Footer;
